const styles = theme => ({
	root: {
		display: 'flex',
	},

	editIcon: {
		color: '#009AC9',
	},

	disabledButton: {
		color: '#C5C5C5',
	},

	checkIcon: {
		color: '#51B383',
	},
	
});

export default styles;